import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveNotificationsRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrieveNotificationsRequestPending() {
      return getState().request.isPending;
    },
    isRetrieveNotificationsRequestSuccess() {
      return getState().request.isSuccessful;
    },
    getNotifications() {
      return getState().notifications;
    },
    getNotificationsTotalPages() {
      return getState().totalPages;
    },
    getNotificationsFilter() {
      return getState().filter;
    },
  };
}

export { createSelector };
